<template>
    <v-dialog persistent width="464" :value="loginDialogShown" content-class="login">
        <v-card height="510">
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="cancel"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            
            <v-card-text style="height: 297px">
                <div>
                    <v-tabs fixed-tabs height="72" v-model="tab">
                        <v-tab class="text-h5">短信验证码登录</v-tab>
                        <v-tab class="text-h5">账号密码登录</v-tab>
                    </v-tabs>
                </div>

                <v-divider></v-divider>

                <v-form lazy-validation ref="f">
                    <div class="pt-8">
                        <v-text-field
                            v-model="phoneNumber"
                            required
                            ref="phoneNumber"
                            :label="tab === 0 ? '手机号' : '账号'"
                            tabindex="1"
                            maxlength="11"
                            validate-on-blur
                            :placeholder="`请输入${tab === 1 ? '注册云班课' : ''}手机号`"
                            :error-messages="phoneError"
                            :rules="[$helper.rules.phoneNumber]"
                        >
                        </v-text-field>

                        <v-text-field
                            v-if="tab === 0"
                            v-model="smsCode"
                            validate-on-blur
                            label="验证码"
                            class="mt-2"
                            tabindex="2"
                            maxlength="4"
                            placeholder="请输入短信验证码"
                            :disabled="!phoneNumber"
                            :error-messages="smsCodeError"
                            :loading="sms.requestingCode"
                        >
                            <template v-slot:append>
                                <v-btn
                                    text
                                    color="primary"
                                    :disabled="sms.countingDown || !phoneNumber"
                                    @click="requestSmsCode"
                                >
                                    {{ sms.countingDown ? `${sms.coolingRemainedSeconds} 秒后重新获取` : '获取验证码' }}
                                </v-btn>
                            </template>
                        </v-text-field>

                        <v-text-field
                            v-if="tab === 1"
                            v-model="password"
                            class="mt-4"
                            label="密码"
                            tabindex="3"
                            maxlength="30"
                            autocomplete="off"
                            placeholder="请输入密码"
                            :error-messages="passwordError"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                            @click:append="showPassword = !showPassword"
                        >
                        </v-text-field>
                        <div v-if="!!errorMessage" class="error--text text-center text-body-2 mt-2">{{ errorMessage }}</div>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions class="px-6">
                <v-spacer></v-spacer>
                <v-btn
                    block
                    color="primary"
                    height="48"
                    :loading="submitting"
                    @click="doLogin"
                ><span style="font-size: 18px">登录</span></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script >
import passportClient from '@/api/passports';

export default {
    name: 'MLoginDialog',

    props: {
        loginDialogShown: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            tab: 0,
            phoneNumber: null,
            smsCode: null,
            phoneError: null,
            smsCodeError: null,
            password: null,
            passwordError: null,
            submitting: false,
            errorMessage: null,

            sms: {
                requestingCode: false,
                countingDown: false,
                generatedOnMs: 0,
                coolingPeriodSeconds: 60,
                coolingRemainedSeconds: 0,
            },

            timerId: 0,

            showPassword: false,
        }
    },

    watch: {
        tab() {
            this.errorMessage = null;
        }, 

        smsCode(val) {
            if (!val) {
                this.smsCodeError = '请输入验证码';
            } else {
                this.smsCodeError = null;
            }
        }
    },

    destroyed() {
        clearInterval(this.timerId);
    },

    mounted: function() {
        this.checkSmsCooling();
        window.removeEventListener('beforeunload', e => this.unloadHandler(e));
    },

    methods: {
        requestSmsCode: function() {
            if (this.$helper.rules.phoneNumber(this.phoneNumber) !== true) {
                return;
            } else {
                this.phoneError = null;
            }

            this.sms.requestingCode = true;
            passportClient.getSmsCode('LGN', this.phoneNumber).then(resp => {
                let data = resp.data.data;

                data = resp.data;
                // this response is generated by core api and returned directly without conversion in books api
                if (data.errorCode && data.errorCode !== '0') {
                    this.smsCodeError = data.errorMessage;
                    return;
                }

                this.sms.generatedOnMs = Date.now();
                this.$store.setItem('smsCodeGeneratedOnMsKey', this.sms.generatedOnMs);
                this.startCountingDown();
            }).finally(() => {
                this.sms.requestingCode = false;
            });
        },

        startCountingDown: function() {
            // 先计算一次剩余时间，再设置 countingDown 为 true,
            // 避免按钮上先出现 “0 秒后重新获取”，然后闪动到正确的倒计时
            if (! this.sms.countingDown) {
                this.sms.countingDown = true;
                this.sms.coolingRemainedSeconds =  this.sms.coolingPeriodSeconds - (Math.round((Date.now() - this.sms.generatedOnMs) / 1000));
            }
            this.timerId = setInterval(() => {
                const passed = Math.round((Date.now() - this.sms.generatedOnMs) / 1000);
                if (passed >= this.sms.coolingPeriodSeconds) {
                    this.sms.countingDown = false;
                    this.$store.deleteItem('smsCodeGeneratedOnMsKey');
                    clearInterval(this.timerId);
                } else {
                    this.sms.coolingRemainedSeconds = this.sms.coolingPeriodSeconds - passed;
                }
            }, 100);
        },
        /**
         * If the page is reloaded
         * check if the sms code requesting is cooling
         */
        checkSmsCooling: function () {
            const ms = this.$store.getItem('smsCodeGeneratedOnMsKey');
            if (! ms || isNaN(parseInt(ms))) return;

            this.sms.generatedOnMs = parseInt(ms);

            const passed = Math.round((Date.now() - this.sms.generatedOnMs) / 1000);

            if (passed < this.sms.coolingPeriodSeconds) {
                this.startCountingDown();
            }
        },

        doLogin: function() {
            if (! this.$refs.f.validate()) {
                return;
            }

            if (this.tab === 0) {
                if (this.$helper.isBlank(this.smsCode)) {
                    this.smsCodeError = '请输入验证码';
                    return;
                }

                if(!(/^\d{4}$/.test(this.smsCode))) {
                    this.smsCodeError = '验证码格式错误';
                    return;
                }
            }

            this.submitting = true;

            const p = this.tab === 0
                ? passportClient.doSmsCodeLogin(this.phoneNumber, this.smsCode)
                : passportClient.doPasswordLogin(this.phoneNumber, this.password);

            p.then(resp => {
                const data = resp.data;

                if (resp.data.errorCode === 'err.invalid.userPassword') {
                    this.submitting = false;
                    this.errorMessage = resp.data.errorMessage;
                    return;
                }

                if (! data || ! data.token) {
                    this.submitting = false;
                    this.errorMessage = '登录失败，请重试';
                    return;
                }

                this.$store.saveToken(data.token);
                this.$store.saveUser(data.user);
                this.$emit('dealDialog', false, true);
            }).catch(res => {
                this.errorMessage = res.errorMessage;
            }).finally(() => {
                this.submitting = false;
            });
        },

        cancel() {
            this.$emit('dealDialog', false, false);
        }

    },
}
</script>

<style>
.login {
    border-radius: 16px !important;
}
</style>